import {
  Alert,
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap"

import { Loading } from "../../components"
import { withTranslation } from "react-i18next"
import React from "react"
import axios from "axios"
import { connect } from "react-redux"
import { fail, fetchResources } from "../../actions"

class CreateAccount extends React.Component {
  state = {
    fetching: false,
    error: null,
    email: "",
    customerId: "",
    isClientAdmin: true,
    sendResetEmail: false,
    accountType: "customer", // "customer" | "reseller"
    resellerId: "",
  }

  componentDidMount = () => {
    this.props.fetchResources({ resource: "resellers" })
  }

  handleChange = ({ target }) => this.setState({ [target.name]: target.value })

  handleCheck = ({ target }) => this.setState({ [target.name]: target.checked })

  submit = (e) => {
    e.preventDefault()

    this.setState({ fetching: true })

    const { email, customerId, isClientAdmin, sendResetEmail } = this.state

    // no password - everyone signs in with AD login,
    // the backend generates a random one
    const request =
      this.state.accountType === "admin"
        ? {
            email,
            isAdmin: true,
          }
        : this.state.accountType === "reseller"
        ? {
            email,
            resellerId: this.state.resellerId,
          }
        : {
            email,
            customerId,
            isClientAdmin,
            sendResetEmail,
          }

    this.createAccount(request)
  }

  createAccount = (request) => {
    const { t } = this.props
    axios
      .post("/users", request)
      .then(this.props.onClose)
      .catch((error) => {
        const data = error?.response?.data
        if (error?.response?.status === 409 && data?.domainMismatch) {
          const message = data.verified
            ? t("_domainMismatchConfirm", {
                emailDomain: data.emailDomain,
                domains: data.domains.join(", "),
              })
            : t("_domainUnknownConfirm", { emailDomain: data.emailDomain })
          if (window.confirm(message)) {
            this.createAccount({ ...request, force: true })
          } else {
            this.setState({ fetching: false })
          }
          return
        }
        this.props
          .fail(null, error)
          .then(() => this.setState({ error, fetching: false }))
      })
  }

  render() {
    const { t } = this.props
    return (
      <Card>
        <CardBody>
          {this.state.fetching ? (
            <Loading small />
          ) : (
            <Form onSubmit={this.submit}>
              <FormGroup>
                <Label for="email">{t("_email")}</Label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="john.doe@example.com"
                  value={this.state.email}
                  onChange={this.handleChange}
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label for="accountType">{t("_accountType")}</Label>
                <Input
                  type="select"
                  name="accountType"
                  id="accountType"
                  onChange={this.handleChange}
                  value={this.state.accountType}
                >
                  <option value="customer">{t("_customer")}</option>
                  <option value="reseller">{t("_reseller")}</option>
                  <option value="admin">{t("_adminUserNoCust")}</option>
                </Input>
              </FormGroup>

              {this.state.accountType === "admin" ? null : this.state
                  .accountType === "reseller" ? (
                <FormGroup>
                  <Label for="resellerId">{t("_reseller")}</Label>
                  <Input
                    type="select"
                    name="resellerId"
                    id="resellerId"
                    onChange={this.handleChange}
                    value={this.state.resellerId}
                  >
                    <option value="">-</option>
                    {(this.props.resellers.resellers || []).map((r) => (
                      <option value={r.id} key={r.id}>
                        {r.name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              ) : (
                <FormGroup>
                  <Label for="customerId">{t("_customer")}</Label>
                  <Input
                    type="select"
                    name="customerId"
                    id="customerId"
                    onChange={this.handleChange}
                    value={this.state.customerId}
                  >
                    {this.props.customers.map((c) => (
                      <option value={c.id} key={c.id}>
                        {c.companyName}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              )}

              {this.state.accountType !== "reseller" &&
              this.state.customerId ? (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      id="isClientAdmin"
                      name="isClientAdmin"
                      checked={this.state.isClientAdmin}
                      onChange={this.handleCheck}
                    />
                    {t("_clientAdmin")}
                  </Label>
                </FormGroup>
              ) : null}

              {this.state.accountType === "customer" && (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      id="sendResetEmail"
                      name="sendResetEmail"
                      checked={this.state.sendResetEmail}
                      onChange={this.handleCheck}
                    />
                    {t("_sendResetMail")}
                  </Label>
                </FormGroup>
              )}

              <hr />

              {this.state.error ? (
                <Alert color="danger">{t("_errorMsg_addAccount")}</Alert>
              ) : null}

              <Button
                type="submit"
                block
                disabled={
                  this.state.accountType === "reseller" &&
                  !this.state.resellerId
                }
              >
                {t("_createAccount")}
              </Button>
            </Form>
          )}
        </CardBody>
      </Card>
    )
  }
}

export default connect((s) => ({ resellers: s.resellers }), {
  fail,
  fetchResources,
})(withTranslation()(CreateAccount))
